// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoadingIndicator_wrapper__31wau","loaderContainer":"LoadingIndicator_loaderContainer__14fWe"};